import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ISupportRequest } from 'src/app/shared/models/stepper/ISupportRequest';
import { IFileRelation } from 'src/app/shared/models/file/IFileRelation';
import { TempFileRelation } from 'src/app/shared/models/file/TempFileRelation';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';
import { map } from 'rxjs/operators';
import { DEFAULT_STEPPER_ITEM_IDS, MAKE_REQUEST_KEY, GET_SUPPORT_KEY } from 'src/constants/local-storage-variables';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService) {}

  public sendStepperForm(data: ISupportRequest, files?: { id: string }[]): Observable<IResponseMessage> {
    const relations: IFileRelation[] = (files || []).map(file => new TempFileRelation({ related_id: file.id }));
    const ignoreKey = ['to', 'name', 'description', 'contact', 'template_id', 'to_id', 'item_id'];
    const params = {
        recordData: {
          portal: true,
          is_main: true,
          name: data.name,
          description: data.description,
          addressbook: data.contact.id,
          company: data.to.id,
          template_id: data.id,
          item_id: data.item_id,
          relations
        },
        ignoreLock: true
    };
    for (const val in data) {
      console.log(val, data[val]);
      let value;
      if (val !== 'undefined' && ignoreKey.includes(val) === false) {
        if (data[val]['key']) {
          value = data[val]['key'];
        } else if (data[val]['id']) {
          value = data[val]['id'];
        } else {
          value = data[val];
        }
        if (val !== 'id') {
          params.recordData[val] = value;
        }
      }
    }
    console.log('data params:', params);
    return this.http.post<IResponseMessage>(this.erService.environmentERS.apiUrl, {
      application: 'CPM',
      method: 'saveTopic',
      parameters: params,
    });
  }

  public initDefaultItemIds(): Observable<{ [key: string]: string }> {
    if (
      localStorage.getItem(DEFAULT_STEPPER_ITEM_IDS[MAKE_REQUEST_KEY]) &&
      localStorage.getItem(DEFAULT_STEPPER_ITEM_IDS[GET_SUPPORT_KEY])
    ) {
      return of({
        [DEFAULT_STEPPER_ITEM_IDS[GET_SUPPORT_KEY]]: localStorage.getItem(DEFAULT_STEPPER_ITEM_IDS[GET_SUPPORT_KEY]),
        [DEFAULT_STEPPER_ITEM_IDS[MAKE_REQUEST_KEY]]: localStorage.getItem(DEFAULT_STEPPER_ITEM_IDS[MAKE_REQUEST_KEY])
      });
    }

    return this.http
      .post<{ [key: string]: string }>(this.erService.environmentERS.apiUrl, {
        application: 'ServiceCatalog',
        method: 'getRegistryData',
        parameters: {}
      })
      .pipe(
        map((response: any) => {
          const defaultItemIds = {};
          response.defaultTemplate.forEach(item => {
            localStorage.setItem(DEFAULT_STEPPER_ITEM_IDS[item.templateType], item.template.id);
            defaultItemIds[DEFAULT_STEPPER_ITEM_IDS[item.templateType]] = item.template.id;
          });
          return defaultItemIds;
        })
      );
  }
}
